import { useState } from "react";

export default function SearchCanvasHook() {
    const [status, setStatus] = useState(false);
    const open = () => { setStatus(true) };
    const close = () => setStatus(false);

    return {
        status: status,
        func: {
            open,
            close
        },
    };
}